/* eslint-disable react-hooks/exhaustive-deps */
import Axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { DIV } from 'src/components/CustomStyledComponents';
import NavbarHeader from 'src/components/header/NavbarHeader';
import LoadingWrapper from 'src/components/Loading/LoadingWrapper';
import useCustomToast from 'src/hooks/useCustomToast';
import useLoading from 'src/hooks/useLoading';
import useQueryString from 'src/hooks/useQueryString';
import { imagenSeguro } from 'src/pipes/imagenes';
import { urlGetProductos, getUrlCrearCotizacion } from 'src/services/urls';
import validator from 'validator';


const HomePage2 = ({ cotizacion }: any) => {
  const [productos, setProductos] = useState([]);

  const { parametros, idUsuario } = useParams<{ parametros: string, idUsuario: string }>()
  const qparams = useQueryString();
  const { values, setLoading, setSecundario, resetLoading } = useLoading(true);

  const { addWarningToast, addErrorToast } = useCustomToast();
  const [state, setstate] = useState({ empAplica: '' })


  const init = useCallback(async () => {

    //Obtiene los parametros para el servicio desde la url 
    let body = validator.isBase64(parametros) && JSON.parse(window.atob(parametros));
    setLoading(true);
    setSecundario('Buscando productos...');

    // Obtiene los productos de la empresa
    try {
      body = { ...body, idUsuario }
      const { data } = await Axios.post(urlGetProductos, body);
      const { logoAseguradora, logoComercial } = data
      setstate((prev) => ({ ...prev, logoAseguradora, logoComercial, ...body }))
      if (data.transaccion) {
        setProductos(data.microseguros);
      } else {
        return addWarningToast('Error obteniendo productos, ', data.mensaje);
      }
    } catch (error) {
      return addErrorToast('Error obteniendo productos');
    }
    resetLoading();
  }, []);

  useEffect(() => {
    init();
  }, [init]);


  // Crea la cotizacion pasando los parametros devueltos en la url 
  const onClick = (producto: any) => async (event: any) => {
    // guardarLead(idCotizacion, `CREAR_COTIZACION_SELECT_PRODUCTO`);
    setSecundario('Buscando información del producto...');

    const codCoreProducto = producto.id
    let body = validator.isBase64(parametros) && JSON.parse(decodeURIComponent(escape(window.atob(parametros))));
    const { usuario = '' } = qparams;
    console.log('usuario', usuario, !!usuario)
    if (!!usuario && usuario !== 'null') {
      body = { ...body, codCoreProducto, idUsuario: usuario, usuCodigoCore: idUsuario }
    }
    else
      body = { ...body, codCoreProducto, idUsuario };

    Axios.post(getUrlCrearCotizacion(), body).then(({ data, status }) => {
      if (data.transaccion) {
        return window.location.href = data.url;
      } else {
        return addWarningToast(`Ha ocurrido un problema al crear cotización,\n ${data?.errorDescripcion}`);
      }
    })
      .catch(error => addErrorToast('Error creando cotización'));
  };
  return (
    <LoadingWrapper {...values}>
      <DIV stylePath="home.globalStyles" className="container-fluid container-page">
        <NavbarHeader {...state} showBack={false} />

        <div className="container__titulo row justify-content-center mt-5">
          <div className="col-12 col-md-10 col-lg-7 ml-2 ml-md-4 align-self-center">
            {state.empAplica === "hyundai" ?
              <h5 id="titulo">Seguros a tu medida, elige el tuyo:</h5> :
              <h5 id="titulo">Elige el plan que mejor se adapte a ti</h5>
            }
          </div>
        </div>

        {productos?.map((producto, index) => (
          <div className="row justify-content-around pointer my-4 " key={producto.id}>
            <div
              className=" container__producto col-12 col-md-10 col-lg-7 card shadow"
              style={{ minHeight: '100px', borderRadius: '0.6rem' }}
            >
              <div className="row" onClick={onClick(producto)}>
                <div className="col-4 text-center align-self-center my-3">
                  <img
                    style={{ maxHeight: '100px' }}
                    className="img-fluid"
                    src={imagenSeguro(producto)}
                    alt={producto.nombre}
                  />
                </div>
                <div className="col-7 col-md-7 border-left border-info my-3">
                  <h5 className="producto__nombre font-weight-bold">{producto.nombre}</h5>
                  <div>
                    <p className="producto__descripcion">{producto.descripcion}</p>
                  </div>
                  {producto?.valoresPagar?.total && producto?.valoresPagar?.total !== "0.00" &&
                    <p className="producto__precio align-self-baseline font-weight-bold">
                      Adquiérelo desde {cotizacion?.moneda?.signo} {producto?.valoresPagar?.total} {cotizacion?.moneda?.sigla}
                    </p>
                  }
                </div>
                <div className="col-1 col-md-1 align-self-center my-3">
                  <i className="pi pi-chevron-right" />
                </div>
              </div>
            </div>
          </div>
        ))}
      </DIV>
    </LoadingWrapper>
  );
};

export default HomePage2;
